module.exports = __webpack_public_path__ + "c2556dc7a917356a1a6a6868f6382cc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/PageLayout/Poster/poster.jpg
// module id = 610
// module chunks = 5